import { commentsData } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          吃瓜群众说
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自真实读者的声音</p>
        <div className="flex flex-col gap-5">
          {commentsData.map((comment, i) => (
            <div key={i} className="bg-background-100 border border-background-200 rounded-xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center text-sm font-bold text-secondary-700">
                  {comment.avatar}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
                <div className="flex items-center gap-1 text-foreground-400">
                  <i className="ri-heart-line text-sm"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}